import styled from 'styled-components';

export const Container = styled.div`
  width: 410px;
  height: 100%;
  border: 1px solid #dedede;
  background-color: #ffffff;
`;

export const Header = styled.header`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22.5px 24px 22.5px 0;
  border-bottom: 1px solid #dedede;
`;

export const RequestInfo = styled.div`
  padding: 16px 0 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #dedede;
`;

export const Info = styled.div`
  display: flex;
  gap: 8px;
`;

export const Description = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LoadingDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80%;
`;
